import React from 'react';
import { Flex, Spinner } from 'ui';
import {
  DocumentsCard,
  OrSeparator,
} from '../components';
import { useController } from './hooks';

export const ClassID = () => {
  const {
    idCard,
    passport,
    isLoading,
  } = useController();

  return (
    <>
      {isLoading && (
        <Flex>
          <Spinner color="gray.500" />
        </Flex>
      )}
      {!isLoading && (
        <>
          <DocumentsCard {...idCard} />
          <OrSeparator />
          <DocumentsCard {...passport} />
        </>
      )}
    </>
  );
};
